import { createActions } from 'redux-actions';
import callApi from 'client/util/apiCaller';

export const {
  twoFactorSetupRequest,
  twoFactorSetupSuccess,
  twoFactorSetupError,
  twoFactorEnableRequest,
  twoFactorEnableSuccess,
  twoFactorEnableError,
  twoFactorDisableRequest,
  twoFactorDisableSuccess,
  twoFactorDisableError,
  twoFactorStatusRequest,
  twoFactorStatusSuccess,
  twoFactorStatusError,
  twoFactorBackupCodesRequest,
  twoFactorBackupCodesSuccess,
  twoFactorBackupCodesError,
  clearTwoFactorError,
} = createActions(
  {},
  'TWO_FACTOR_SETUP_REQUEST',
  'TWO_FACTOR_SETUP_SUCCESS',
  'TWO_FACTOR_SETUP_ERROR',
  'TWO_FACTOR_ENABLE_REQUEST',
  'TWO_FACTOR_ENABLE_SUCCESS',
  'TWO_FACTOR_ENABLE_ERROR',
  'TWO_FACTOR_DISABLE_REQUEST',
  'TWO_FACTOR_DISABLE_SUCCESS',
  'TWO_FACTOR_DISABLE_ERROR',
  'TWO_FACTOR_STATUS_REQUEST',
  'TWO_FACTOR_STATUS_SUCCESS',
  'TWO_FACTOR_STATUS_ERROR',
  'TWO_FACTOR_BACKUP_CODES_REQUEST',
  'TWO_FACTOR_BACKUP_CODES_SUCCESS',
  'TWO_FACTOR_BACKUP_CODES_ERROR',
  'CLEAR_TWO_FACTOR_ERROR',
);

// Setup 2FA (generate secret and QR code)
export function setup2FA() {
  return (dispatch, _getState) => {
    dispatch(twoFactorSetupRequest());

    // Use regular session token from cookies
    return callApi(dispatch, 'auth/2fa/setup', null, 'post')
      .then(response => {
        dispatch(twoFactorSetupSuccess(response));
        return response;
      })
      .catch(error => {
        dispatch(twoFactorSetupError(error.message));
        throw error;
      });
  };
}

// Enable 2FA with TOTP verification
export function enable2FA(token) {
  return (dispatch, _getState) => {
    dispatch(twoFactorEnableRequest());

    return callApi(dispatch, 'auth/2fa/enable', null, 'post', { token })
      .then(response => {
        dispatch(twoFactorEnableSuccess(response));
        return response;
      })
      .catch(error => {
        dispatch(twoFactorEnableError(error.message));
        throw error;
      });
  };
}

// Disable 2FA
export function disable2FA(token) {
  return (dispatch, _getState) => {
    dispatch(twoFactorDisableRequest());

    return callApi(dispatch, 'auth/2fa/disable', null, 'post', { token })
      .then(response => {
        dispatch(twoFactorDisableSuccess(response));
        return response;
      })
      .catch(error => {
        dispatch(twoFactorDisableError(error.message));
        throw error;
      });
  };
}

// Get 2FA status
export function get2FAStatus() {
  return (dispatch, getState) => {
    dispatch(twoFactorStatusRequest());
    const token = getState().auth.profile?.token;

    return callApi(dispatch, 'auth/2fa/status', token, 'get')
      .then(response => {
        dispatch(twoFactorStatusSuccess(response));
        return response;
      })
      .catch(error => {
        dispatch(twoFactorStatusError(error.message));
        throw error;
      });
  };
}

// Regenerate backup codes
export function regenerateBackupCodes(token) {
  return (dispatch, _getState) => {
    dispatch(twoFactorBackupCodesRequest());

    return callApi(dispatch, 'auth/2fa/backup-codes', null, 'post', { token })
      .then(response => {
        dispatch(twoFactorBackupCodesSuccess(response));
        return response;
      })
      .catch(error => {
        dispatch(twoFactorBackupCodesError(error.message));
        throw error;
      });
  };
}

// Complete 2FA login
export function complete2FALogin(userId, token) {
  return dispatch => {
    return callApi(dispatch, 'public/auth/2fa/complete', null, 'post', { userId, token }).then(
      response => {
        // Cookies are now handled centrally in the receiveLogin action
        return response;
      },
    );
  };
}
